import { render, staticRenderFns } from "./StoreSupportForm.vue?vue&type=template&id=7fce5d68&"
import script from "./StoreSupportForm.vue?vue&type=script&lang=js&"
export * from "./StoreSupportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports